<script>
import XTable from "@/components/table/XTable.vue";
import { getFirstAndLastDayOfMonth, accAdd } from '@/vue/util/tool'
import {mapGetters} from "vuex";
import {
  departmentFind,
  employeeQuery,
  queryAchievementStatistic,
  queryAchievementInfo,
} from "../../api/manageCenter";
function addNum() {
  let t = 0;
  for (let i = 0; i < arguments.length; i++) {
    const n = Number(arguments[i])
    if(!isNaN(n)) {
      t+=n;
    }
  }
  return t;
}
/**
 * @param.num = string
 * @return number
 * */
function formatNumber(num) {
  if (!num) return 0;
  if (num.includes('万元')) {
    num = num.replace('万元', '');
    num = Number(num) * 10000;
    num = num.toString();
  }
  num = num.replace('元', '');
  return Number(num)
}

// 业绩统计页面
export default {
  name: "performanceStatistics",
  components: {XTable},
  data() {
    // 示例用法
    const date = getFirstAndLastDayOfMonth();
    return {
      param: {
        date: date,
        type: 2, // 类型
        employeeId: '', // 人员
        employeeName: '', // 员工姓名
        departmentId: '', // 部门id
        departmentname: '', // 部门名称
      },
      departmentList: [],
      allUserList: [],
      departpopshow: false,
      List: [],
      excelName: '业绩提成统计',
      dialog: {
        show: false,
        title: '',
        param: {
          contractType: '', // 合同类型
          type: '', // 类型  1人员 2部门
          date: '', // 时间
          departmentId: '', // 部门编号
          employeeId: '', // 人员
        },
        data: [],
        columns2: [
          { label: '合同编号', prop: 'contractCode', width: '90px' },
          { label: '类型', prop: 'contractType', width: '80px' },
          { label: '房源编号', prop: 'houseCode', width: '90px' },
          { label: '客源编号', prop: 'cusCode', width: '90px' },
          { label: '成交金额', prop: 'finalPrice', width: '105px' },
          { label: '应收业绩(元)', prop: 'commission', width: '105px' },
          { label: '实收业绩(元)', prop: 'achievement', width: '105px' },
          { label: '房源地址', prop: 'houseAddr', 'showOverflowTooltip': true},
          { label: '签约人', prop: 'signer', width: '80px' },
          { label: '签约日期', prop: 'signDate', width: '105px' },
          // { label: '签约人编号', prop: 'signerId' },
          // { label: '房源类型', prop: 'housingProperty' },
          // { label: '客户编号', prop: 'customerId' },
          // { label: '客户编号', prop: 'customerId' },
          // { label: '客户维护人编号', prop: 'cusEmployeeId' },
          // { label: '客源类型', prop: 'customerType' },
        ]
      },
    }
  },
  computed: {
    ...mapGetters(['contractType']),
    columns() {
      const column = [
        { label: '日期', prop: 'yearOrMonth' },
        { label: '部门', prop: 'departmentName', 'showOverflowTooltip': true, width: '200px' },
        { label: '新房(元)', prop: 'newMoney' },
        { label: '二手房(元)', render: 'secondMoney' },
        { label: '租房(元)', render: 'rentMoney' },
        { label: '商铺买卖(元)', render: 'shopSaleMoney' },
        { label: '商铺租赁(元)', render: 'shopRentMoney' },
        { label: '代办手续(元)', render: 'handlingMoney' },
        { label: '其他(元)', render: 'otherMoney' },
        { label: '总业绩(元)', prop: 'achievement' },
        // { label: '提成业绩(元)', prop: 'commissionMoney' },
      ]
      if (this.param.type === 1) {
        column.splice(2,0, { label: '人员', prop: 'employeeName' })
      }
      return [...column]
    },
    fields() {
      return this.columns.reduce((obj, item) => {
        obj[item.label] = item.prop;
        return obj
      }, {})
    },
    userList() {
      if (!this.param.departmentId) {
        return this.allUserList;
      }
      return this.allUserList.filter(i=> this.param.departmentId === i.departmentId);
    }
  },
  methods: {
    getTableData(pages) {
      let date = this.param.date || [];
      if (date.length) {
        date = [
          date[0].toLocaleString().split(' ')[0].replace(/\//g, '-'),
          date[1].toLocaleString().split(' ')[0].replace(/\//g, '-'),
        ]
      }
      return this.$post(queryAchievementStatistic, {
        'page.pageNumber': (pages.current - 1) * pages.size,
        'page.pageSize': pages.size,
        ...this.param,
        date,
      }).then(res => {
        if (res.data && res.data.length) {
          res.data.push({
            yearOrMonth: '合计：',
            newMoney: res.data.reduce((t, i) => accAdd(t, i.newMoney), 0),
            secondMoney: res.data.reduce((t, i) => accAdd(t, i.secondMoney), 0),
            rentMoney: res.data.reduce((t, i) => accAdd(t, i.rentMoney), 0),
            shopRentMoney: res.data.reduce((t, i) => accAdd(t, i.shopRentMoney), 0),
            shopSaleMoney: res.data.reduce((t, i) => accAdd(t, i.shopSaleMoney), 0),
            handlingMoney: res.data.reduce((t, i) => accAdd(t, i.handlingMoney), 0),
            otherMoney: res.data.reduce((t, i) => accAdd(t, i.otherMoney), 0),
            achievement: res.data.reduce((t, i) => accAdd(t, i.achievement), 0),
          })
          // res.data.forEach(item => {
          //   item.totalMoney = addNum(
          //       item.newMoney,
          //       item.secondMoney,
          //       item.rentMoney,
          //       item.shopRentMoney,
          //       item.shopSaleMoney,
          //       item.handlingMoney,
          //       item.otherMoney,
          //   )
          // })
          this.List = res.data;
        }
        return {
          total: res.total,
          records: res.data,
        }
      })
    },
    reload() {
      this.$refs.table.load(true)
    },
    // 查询部门
    getdepartmentFind() {
      this.$post(departmentFind).then(res => {
        if (res.success) {
          this.departmentList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    // 合同详情
    gotodetail(row) {
      sessionStorage.setItem("contractId", row.contractId);
      sessionStorage.setItem("concractEmployeeId", row.signerId);
      sessionStorage.setItem("electronictype", row.contractType);
      // sessionStorage.setItem("contractStatus", row.status); // todo
      // sessionStorage.setItem("electronic", row.electtionContractId); // todo
      this.$router.push({ path: "/contractDetails" });
      sessionStorage.setItem("concractFrom", "contracdetails");
    },
    departmentnameClear() {
      this.param.departmentname = '';
      this.param.departmentId = '';
      this.reload();
    },
    //选择部门
    handleNodeClick(node) {
      this.param.departmentId = node.id;
      this.param.departmentname = node.name;
      this.departpopshow = false;
      this.reload();
    },
    getUserList() {
      const params = {
        "page.pageNumber": 1,
        "page.pageSize": 1000,
      };
      this.$post(employeeQuery, params).then(res => {
        if (res.success === true) {
          this.allUserList = res.data;
        }
      });
    },
    typeChange() {
      this.param.employeeId = '';
      this.param.employeeName = '';
      this.param.departmentId = '';
      this.param.departmentname = '';
      this.reload();
    },
    openDialog(row, contractType, contractName) {
      /**
       * case "0" : return "新房";
       * case "1" : return "二手房";
       * case "2" : return "住房租赁";
       * case "3" : return "商铺";
       * case "4" : return "商铺租赁";
       * case "5" : return "代办手续";
       * case "6" : return "其他";
       */
      console.log(row);
      if (row.yearOrMonth && row.yearOrMonth.includes('合计')) return;
      this.dialog.show = true;
      this.dialog.title = `${row.departmentName}-${row.employeeName||''}${contractName}业绩明细`;
      this.dialog.param = {
        employeeId: row.employeeId,
        departmentId: row.departmentId,
        date: row.yearOrMonth.split('~'),
        type: this.param.type,
        contractType,
      }
      this.$refs.dialogTable?.load(true);
    },
    getDialogTableData(pages) {
      return this.$post(queryAchievementInfo, {
        'page.pageNumber': (pages.current - 1) * pages.size,
        'page.pageSize': pages.size,
        ...this.dialog.param,
      }).then(res => {
        if (res.data && res.data.length) {
          const finalPrice = res.data.reduce((t, i) => accAdd(t, formatNumber(i.finalPrice)), 0);
          res.data.push({
            contractCode: '合计：',
            finalPrice: finalPrice > 10000 ? `${finalPrice / 10000}万元` : `${finalPrice}元`,
            commission: res.data.reduce((t, i) => accAdd(t, i.commission), 0),
            achievement: res.data.reduce((t, i) => accAdd(t, i.achievement), 0),
          })
          this.List = res.data;
        }
        return {
          total: res.total,
          records: res.data,
        }
      })
    },
  },
  mounted() {
    this.getUserList();
    this.getdepartmentFind();
  },
}
</script>

<template>
  <div class="collectionStatistics">
    <ul class="jobs_list">
      <li class="jobs_item">
        <span class="title-dec">签约日期：</span>
        <el-date-picker
            v-model="param.date"
            @change="reload"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </li>
      <li class="jobs_item">
        <span class="title-dec">类型：</span>
        <el-select class="short" v-model="param.type" @change="typeChange" size="mini">
          <el-option label="人员" :value="1"></el-option>
          <el-option label="部门" :value="2"></el-option>
        </el-select>
      </li>
      <li class="jobs_item conditions_list_item">
        <span class="title-dec">部门：</span>
        <el-input
            v-model="param.departmentname"
            @focus="departpopshow=!departpopshow"
            placeholder="请选择"
            clearable
            @clear="departmentnameClear"
            style="width: 160px;"
            size="mini"
        />
        <div class="departpop" v-show="departpopshow">
          <el-tree
              :default-expand-all="true"
              :data="departmentList"
              :props='{ children: "child"}'
              @node-click="handleNodeClick"
          >
              <span class="custom-tree-node" slot-scope="{data}">
                <div>
                  <img class="tree-icon" v-if="data.labelName==='区'" src="../../assets/icon/quyu.png" alt />
                  <img class="tree-icon" v-if="data.labelName==='店'" src="../../assets/icon/dian.png" alt />
                  <img class="tree-icon" v-if="data.labelName==='组'" src="../../assets/icon/zu.png" alt />
                  <span>{{ data.name }}</span>
                </div>
              </span>
          </el-tree>
        </div>
      </li>
      <li class="jobs_item" v-show="param.type === 1">
        <span class="title-dec">员工：</span>
        <el-select
            v-model="param.employeeId"
            placeholder="请选择"
            size="mini"
            class="short"
            @change="reload"
            clearable
        >
          <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </li>
      <li style="margin-left: auto;">
        <download-excel class="export-excel-wrapper" :data="List" :fields="fields" :name="excelName">
          <el-button type="primary" style="background:#5E75E6;" size="mini">导出</el-button>
        </download-excel>
      </li>
    </ul>
    <XTable
        class="xtable"
        :data="getTableData"
        :columns="columns"
        ref="table"
        :table="{ headerCellStyle: ()=>'background-color: #F2F4FF', border: true }"
        :page="{pageSize: 20}"
        showPage
        firstRendder
        show-all-btn
    >
      <template v-slot:secondMoney="{row, $index}">
        <span
            style="cursor: pointer;color: #5E75E6"
            @click="openDialog(row, '1', '二手房')"
        >
          {{row.secondMoney}}
        </span>
      </template>
      <template v-slot:rentMoney="{row, $index}">
        <span
            style="cursor: pointer;color: #5E75E6"
            @click="openDialog(row, '2', '住房租赁')"
        >
          {{row.rentMoney}}
        </span>
      </template>
      <template v-slot:shopSaleMoney="{row, $index}">
        <span
            style="cursor: pointer;color: #5E75E6"
            @click="openDialog(row, '3', '商铺买卖')"
        >
          {{row.shopSaleMoney}}
        </span>
      </template>
      <template v-slot:shopRentMoney="{row, $index}">
        <span
            style="cursor: pointer;color: #5E75E6"
            @click="openDialog(row, '4', '商铺租赁')"
        >
          {{row.shopRentMoney}}
        </span>
      </template>
      <template v-slot:handlingMoney="{row, $index}">
        <span
            style="cursor: pointer;color: #5E75E6"
            @click="openDialog(row, '5', '代办手续')"
        >
          {{row.handlingMoney}}
        </span>
      </template>
      <template v-slot:otherMoney="{row, $index}">
        <span
            style="cursor: pointer;color: #5E75E6"
            @click="openDialog(row, '6', '其他')"
        >
          {{row.otherMoney}}
        </span>
      </template>
    </XTable>
    <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.show"
        width="1000px"
    >
      <XTable
          class="xtable"
          :data="getDialogTableData"
          :columns="dialog.columns2"
          ref="dialogTable"
          :table="{ headerCellStyle: ()=>'background-color: #F2F4FF', border: true }"
          :page="{pageSize: 20}"
          showPage
          firstRendder
      ></XTable>

    </el-dialog>
  </div>
</template>

<style scoped lang="less">
.jobs_list {
  display: flex;
  justify-content: flex-start;
  margin: 15px;
  .jobs_item {
    display: flex;
    align-items: center;
    margin-right: 15px;
    .title-dec {
      white-space: nowrap;
    }
  }
  .short {
    width: 120px;
  }
  .el-input__inner {
    width: 170px;
    height: 30px;
    border-radius: 0;
    border: 1px solid #ccc;
    padding-right: 5px;
  }
  .el-date-editor {
    width: 250px;
  }
}
.xtable {
  /deep/ .red {
    color: red;
  }
  /deep/ tbody tr:last-child td {
    border: none;
    color: red;
    span {
      color: red !important;
      cursor: auto !important;
    }
  }
}
.conditions_list_item {
  position: relative;
}
.departpop {
  width: 160px;
  position: absolute;
  left: 64px;
  top: 41px;
  z-index: 10;
  border: 1px solid #eee;
  font-size: 14px;
  .el-tree {
    padding: 5px 0;
    .tree-item {
      display: flex;
      align-items: center;
      img {
        padding-right: 10px;
      }
    }
  }
}
</style>
